export default __webpack_public_path__ + "static/media/Dr. Chitta Ranjan Satapathy.a4537cb1.png";